export const UBIK_TRACKING_BREADCRUMBS_LABEL = 'Breadcrumbs'

export const UBIK_TRACKING_LINK_ATTRIBUTES = {
  'data-ubik-event-type': 'click',
  'data-ubik-event-subtype': 'navigation',
}
